import React from 'react';
import './UserDoktorLeftSide.css';

const UserDoktorLeftSide = () => {
    return (
        <section className="register-doktor-left-section">
            <p className='base-metin'>Uygun resimler ya da kurumsal bir <a href='deneme'>illüstrasyon</a></p>
        </section>
    );
};

export default UserDoktorLeftSide;
